import { useEffect, useRef, useState } from "react"
import LoadingPage from "../../components/LoadingPage"
import ReactToPDF from 'react-to-pdf';
import StudentReport from './StudentReport.js';

export default function Component(props){

    const [data,setData]=useState([])
    const [isLoading,setisLoading]=useState(false)
    async function fetchData(){
        setisLoading(true)
        let d = await props.fetch()
        if(d){
            setData(d)
        }
        setisLoading(false)
    }
    useEffect(()=>{
        fetchData()
    },[props.fetch])

    const getClassList = () => {
        let array = [];
        for(let i = 0; i < data?.length; i++) {
            const student = data[i].student;
            if(student?.class && !array.includes(student.class)) {
                array.push(student.class);
            }
        }
        return array.sort((a,b)=>a>b?1:-1);
    }
    const [classFilter,setClassFilter]=useState('全部')
    const filterDate = data?.filter((item) => classFilter === '全部' || item.student.class === classFilter)

    const printRef = useRef([]);
    const print = async () => {
        for(let i = 0; i < filterDate.length; i++) {
            let done = await ReactToPDF({current:printRef.current[i]},{filename: `${filterDate[i].student?.name}-閱讀成績單.pdf`})
        }
    }
    useEffect(() => {
        printRef.current = printRef.current.slice(0, filterDate.length);
     }, [filterDate]);
    return(
        <div className="absolute top-0 left-0 w-full h-full bg-[#00000080] flex justify-center items-center" style={{overflow:'hidden'}}>
            <div className="bg-white max-w-[90%] max-h-[90%] rounded-[8px] flex flex-col">
                <div className="flex flex-row items-center justify-between p-[16px] rounded-[8px] gap-[64px]">
                    <div className="text-[20px] font-[700] text-[#1D1D41]">下載閱讀成績單</div>
                    <div className="cursor-pointer text-[16px] font-[700] text-[#1D1D41]" onClick={props.close}>X</div>
                </div>

                <div className='flex flex-row w-full bg-[white] rounded-[10px] p-[16px] text-[14px] flex-wrap gap-[16px] justify-start' style={{  }}>
                    班級: <div className='cursor-pointer px-[8px]' onClick={()=>{setClassFilter('全部')}} style={{color:classFilter==='全部'?'#1F4CC8':'#898989',fontWeight:classFilter==='全部'?700:300}}>全部</div>
                    {getClassList().map((item,index)=>
                        <div key={index} className='cursor-pointer px-[8px]' onClick={()=>{setClassFilter(item)}} style={{color:classFilter===item?'#1F4CC8':'#898989',fontWeight:classFilter===item?700:300}}>{item}</div>
                    )}
                </div>
                <div className='w-full flex flex-row p-[16px] items-center gap-[14px] my-[24px]'>
                    學生總數:
                    <div className='text-[32px] font-[700]'>{filterDate?.length}</div>
                </div>
                <button className="text-[20px] font-[700] text-[white] bg-[blue] rounded-[8px] p-[8px] m-[16px]"  onClick={print} >下載</button>
            </div>
            <div className="absolute w-full top-[100%] flex-col justify-start" style={{display:'flex'}}>
                <div className="w-full flex flex-col gap-[64px] justify-start"  style={{overflowY:'auto'}}>
                {filterDate?.map((item,index)=>
                    <div ref={el => printRef.current[index] = el}  key={index} className='w-full'>
                        <StudentReport mission={item}/>
                    </div>
                )}
                </div>
            </div>
            {isLoading&&<LoadingPage/>}
        </div>
    )
}